import { api } from "@/plugins/api";

const state = {
  user: null,
  error: null,
  registrationResult: null,
};

const getters = {
  getUser: (state) => state.user,
  userLoggedIn: (state) => state.user !== null,
  getError: (state) => state.error,
  getRegResult: (state) => state.registrationResult,
};

const actions = {
  async login({ commit }, credentials) {
    try {
      const resp = await api.post("/login", credentials);
      console.log("err", resp.status);
      if (resp.status == 200) {
        const user = resp.data;
        commit("setUser", user);
      }
    } catch (error) {
      commit("setError", error);
    }
  },
  async logout({ commit }) {
    commit("clearUserData");
    return true;
  },
  async register({ commit }, userData) {
    try {
      const result = await api.post("/register", userData);
      commit("setRegistrationResult", {
        success: true,
        result: result,
      });
    } catch (error) {
      commit("setRegistrationResult", {
        success: false,
        message: error.message,
      });
    }
  },
};

const mutations = {
  setRegistrationResult(state, result) {
    state.registrationResult = result;
  },
  setUser(state, user) {
    state.user = user;
    localStorage.setItem("user", JSON.stringify(user));
    //api.defaults.headers.common.Authorization = `Bearer ${user.token}`;
  },
  clearUserData(state) {
    localStorage.removeItem("user");
    state.user = null;
    state.error = null;
    location.reload();
  },
  setError(state, error) {
    state.error = error.message;
    console.log("errr", state.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
